import React, {useEffect, useState} from 'react';

const Select = ({name, label, options, value, onChange}) => {
    return (
        <>
            <label className="form-label col-form-label-sm" htmlFor={name}>{label}</label>
            <select className="form-select form-select-sm" name={name} id={name} value={value} onChange={(event) => onChange(event.target.value)}>
                {options.map(option => <option key={option.value} value={option.value}>{option.name}</option>)}
            </select>
        </>
    )
}

export default Select